(typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}).SENTRY_RELEASE = {
  id: "bc9ae72d30c3acd8c662de78b76e6279f78b4cfd"
};